module.exports = __webpack_public_path__ + "static/media/face-male-4.4f394bd7.jpg";